import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose, IconDropdownSelected} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal,Select, Tag,Popover} from "antd";
import {t} from "i18next";
import {
    generateUUID2, getImagePath,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    isDarkMode,
    isStringNullOrEmpty
} from "../../utils";
import {
    ARRAY_PROPERTY_OPTIONS_COLOR,
    ARRAY_PROPERTY_TYPE, getDefaultTagBackgroundColor, getPropertySelectOptionBackgroundColor,
    IMPORT_FILE_MODE_IMPORTMODE,
    KEY_MACHINEID, KEY_TABLEVIEW_TAG_BACKGROUND_INDEX
} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import {updateProperty} from "@model/Property";
import { DndContext, DragEndEvent, PointerSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, horizontalListSortingStrategy, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import global from "@/global";
import {getTagBackgroundIndex, setTagBackgroundIndexAdd} from "@/LocalStroageUtils";

const DialogAddProperty = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const txtNameRef = useRef(null);

    const [property,setProperty] = useState<any>(null);
    const [arrayPropertyType,setArrayPropertyType] = useState<any>([]);
    const [isNew,setIsNew] = useState(true);
    const [isEnabledSelected,setIsEnabledSelected] = useState(true);

    const sensors = useSensors(useSensor(PointerSensor));
    const mCallback = useRef(null);

    useEffect(() => {
        const arrayPropertys = [...ARRAY_PROPERTY_TYPE()];
        for (let i=0;i<arrayPropertys.length;i++){
            arrayPropertys[i].value = arrayPropertys[i].id;
            arrayPropertys[i].label = <div className={'flex-row-vertical-center'}><img className={'img-14'} src={getImagePathWithThemeSvg(arrayPropertys[i].icon)}/><span className={'ml-8'}>{arrayPropertys[i].name}</span></div>
        }
        setArrayPropertyType(arrayPropertys);
    }, []);

    const onShowDialog = (property0:any,callback)=>{
        setIsShowDialog(true);
        mCallback.current = callback;
        if (property0){
            setProperty(property0);
            setIsNew(false);
            if (property0?.type == 'multiSelect' || property0?.type == 'select'){

            }
            setIsEnabledSelected(false);
        }else{
            setProperty({
                id:generateUUID2(),
                createTime:Date.now()
            });
        }

        setTimeout(()=>{
            txtNameRef.current?.focus();
        },200)
    }

    const onConfirm = ()=>{
        if (!property.name) {
            message.destroy();
            message.error(t('PleaseEnterTheName'));
            return;
        }
        if (!property.type) {
            message.destroy();
            message.error(t('PleasePropertyType'));
            return;
        }
        //保存.
        const newProperty = {...property};
        newProperty.groupName = 'custom';
        newProperty.updateTime = Date.now();
        // newProperty.propertySort = 0;

        const propertyType = ARRAY_PROPERTY_TYPE().find(p=>p.id == newProperty.type);
        newProperty.icon = propertyType?.icon;
        updateProperty(newProperty).then(res=>{
            props.onCloseCallback();
            //刷新列表
            window.globalRefreshList('refresh_page_property_');
            //刷新-tag界面中的add property
            window.globalRefreshList('refresh_property_list_');
            if (mCallback.current){
                mCallback.current(newProperty);
            }
        })
    }



    //拖动排序的
    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        if (!over) {
            return;
        }
        if (active.id !== over.id) {
            const newProperty = {...property};

            const oldIndex = newProperty.items.findIndex((item) => item.id === active.id);
            const newIndex = newProperty.items.findIndex((item) => item.id === over.id);
            const arrayNewItem = arrayMove(newProperty.items, oldIndex, newIndex);

            newProperty.items = arrayNewItem;
            setProperty(newProperty);
        }
    };


    // @ts-ignore
    return <Modal width={520} zIndex={2005} bodyStyle={{}}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{isNew?t('CreateNewProperty'):t('Edit property')}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <span className={'mt-12'}>{t("Name")}</span>
            <input ref={txtNameRef} className={'input-border mt-10'} placeholder={t('PleaseEnterPropertyName')}
                   value={property?.name} onInput={(e) => {
                const newLink = {...property};
                newLink.name = e.currentTarget.value;
                setProperty(newLink);
            }}/>

            <span className={'mt-18'}>{t("Type")}</span>
            <Select className={'mt-10'}
                    disabled={!isEnabledSelected}
                    dropdownClassName={'shadow'}
                    placeholder={t("Select type")}
                    value={property?.type}
                    options={arrayPropertyType}
                    suffixIcon={<IconDropdownSelected/>} onChange={(e)=>{
                        const newProperty = {...property};
                        newProperty.type = e;
                        if ((e == 'multiSelect' || e == 'select') && !newProperty.items) {
                            newProperty.items = [];
                        }
                        setProperty(newProperty);
            }}/>

            {
                (property?.type == 'multiSelect' || property?.type == 'select') &&
                <div className={'mt-22'}>
                    <div className={'flex-row-vertical-center'}>
                        <span>{t('Options')}</span>
                        <div className={'flex-row-vertical-center cursor-pointer'} style={{marginLeft:'auto'}} onClick={(e)=>{
                            const newProperty = {...property};
                            let nTagBackgroundIndex = getTagBackgroundIndex();
                            newProperty.items.push({
                                id:generateUUID2(),
                                text:'',
                                sort:0,
                                isEditable:true,
                                backgroundColor:ARRAY_PROPERTY_OPTIONS_COLOR[nTagBackgroundIndex].usedColor
                            })
                            setProperty(newProperty);
                            setTagBackgroundIndexAdd(nTagBackgroundIndex);
                        }}>
                            <img className={'img-14'} src={getImagePath('add_blue')}/>
                            <span className={'ml-8 primary-color'}>{t("Add option")}</span>
                        </div>
                    </div>

                    {
                        property?.items &&
                        <div className={isDarkMode() ? 'drag-dashed-border-dark' : 'drag-dashed-border'}
                             style={{margin: '8px 0', height: '150px', width: '470px',overflow:'hidden auto',}}>
                            <DndContext sensors={sensors} onDragEnd={handleDragEnd} collisionDetection={closestCenter}>
                                <SortableContext items={property?.items} strategy={verticalListSortingStrategy}>
                                    <div className={'flex-col'} style={{gap:'2px 0px',padding:'8px 8px 8px 8px'}}>
                                        {property?.items?.map((item:any) => (
                                            <DraggableTag tag={item} key={item.id} onUpdate={(tag)=>{
                                                const newProperty = {...property};
                                                if (tag.text){
                                                    const item = newProperty.items.find(p=>p.id == tag.id);
                                                    item.isEditable = false;
                                                    item.text = tag.text;
                                                    item.backgroundColor = tag.backgroundColor;
                                                }else{
                                                    const nIndex = newProperty.items.findIndex(p=>p.id == tag.id);
                                                    newProperty.items.splice(nIndex,1);
                                                }

                                                setProperty(newProperty);
                                            }}/>
                                        ))}
                                    </div>
                                </SortableContext>
                            </DndContext>
                        </div>
                    }
                </div>

            }

            <div className={'flex-center mt-22 mb-4'}>
                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        onConfirm();
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Save")}</Button>
            </div>
        </div>
    </Modal>
})


export default DialogAddProperty;



//drag tag.....
interface Item {
    id: number;
    text: string;
}

interface DraggableTagProps {
    tag: Item;
    onUpdate:(tag:any)=>void;
}
const commonStyle: React.CSSProperties = {
    cursor: 'move',
    transition: 'unset', // Prevent element from shaking after drag
    // display:'block',
    height:'26px',
    lineHeight:'26px',
    border:'none'
};

const DraggableTag: React.FC<DraggableTagProps> = (props:{tag:any,onUpdate:any}) => {
    const { tag } = props;
    const { listeners, transform, transition, isDragging, setNodeRef } = useSortable({ id: tag.id });
    const [isInputFocus,setIsInputFocus] = useState(false);
    const [isHovered,setIsHoverd] = useState(false);
    const style = transform
        ? {
            ...commonStyle,
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
            transition: isDragging ? 'unset' : transition, // Improve performance/visual effect when dragging
        }
        : commonStyle;

    const onUpdateOption = (e)=>{
        const newTag = {...tag,text:e.currentTarget.value}
        props.onUpdate(newTag);
    }

    const renderMore = ()=>{
        return<div className={'flex-col'}>
            <input className={'input-border'} style={{border:isInputFocus?'1px solid var(--text-focus-border-color)':'1px solid var(--input-border-color)'}} value={tag.text} onFocus={(e)=>{
                setIsInputFocus(true)
            }} onBlur={(e)=>{
                setIsInputFocus(false);
            }} onInput={(e)=>{
                const newTag = {...tag,text:e.currentTarget.value}
                props.onUpdate(newTag);
            }}/>
            <div className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3'} style={{height:'32px',margin:'8px -12px 0px -12px'}} onClick={(e)=>{
                //删除
                const newTag = {...tag,text:''};
                props.onUpdate(newTag);
            }}>
                <img className={'img-16 ml-20'} src={getImagePathWithThemeSvg('option_delete')}/>
                <span className={'ml-8'}>{t('Delete option')}</span>
            </div>
            <div className={'line mt-12'} style={{margin:'8px -12px'}}></div>
            <div className={'mt-2'} style={{display:'grid',padding:'0 8px',gap:'12px 0', gridTemplateColumns:'repeat(4,auto)',justifyContent:'space-between'}}>
                {
                    ARRAY_PROPERTY_OPTIONS_COLOR.map(p=>{
                        return<div className={'cursor-pointer'} style={{width:'32px',height:'32px',borderRadius:'8px',background:`${isDarkMode()?p.useDarkColor:p.color}`}} onClick={(e)=>{
                            const newTag = {...tag,backgroundColor:p.usedColor};
                            props.onUpdate(newTag);
                        }}>

                        </div>
                    })
                }
            </div>

        </div>
    }

    return (
        <div className={'flex-row-vertical-center hovered-777-radius-8'} style={{height:'36px',paddingLeft:'6px'}} onMouseEnter={(e)=>{
            setIsHoverd(true);
        }} onMouseLeave={(e)=>{
            setIsHoverd(false);
        }}>
            {
                tag.isEditable?<input autoFocus={true} className={'input-border'} style={{width:'100%'}} onKeyDown={(e)=>{
                    if (e.key == KEYS.ENTER){
                        onUpdateOption(e);
                    }
                    }} onBlur={(e)=>{
                        onUpdateOption(e);
                    }}/>:
                    <>
                        <Tag style={{...style,backgroundColor:getPropertySelectOptionBackgroundColor(tag.backgroundColor),color:'var(--text-color)'}} ref={setNodeRef} {...listeners}>
                            {tag.text}
                        </Tag>
                        {
                            isHovered &&
                            <Popover trigger={['click']} content={renderMore()} arrow={false} overlayInnerStyle={{width:'200px'}} placement={'rightTop'}>
                                <img style={{marginLeft: 'auto'}} className={'img-12 cursor-pointer mr-10'}
                                     src={getImagePathWithTheme('note_card_h_more')}/>
                            </Popover>
                        }

                    </>
            }
        </div>

    );
};